// CourseNav.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./course_nav.css";

import SearchBar from "./searchbar";

export default function CourseNav(props) {
  const {
    logout,
    currentUser,
    color,
    fetchClients,
    clients,
    fetchClientAppts,
    clientAppts,
  } = props;

  const [profile, setProfile] = useState(false);

  function toggleProfile(e) {
    e.stopPropagation();
    setProfile((prev) => !prev);
  }

  function closeProfile() {
    setProfile(false);
  }

  return (
    <div className="course-nav" onClick={closeProfile}>
      <SearchBar
        fetchClients={fetchClients}
        clients={clients}
        fetchClientAppts={fetchClientAppts}
        clientAppts={clientAppts}
      />

      <div
        onClick={toggleProfile}
        className="hamburger"
        role="button"
        tabIndex={0}
        aria-label="Open profile menu"
      >
        <i className="fas fa-user" />
      </div>

      <div
        className={profile ? (color ? "profile-p" : "profile") : "hidden"}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="scheduled-appt-title moving-gradient w-100">
          {currentUser ? `${currentUser.first_name} ${currentUser.last_name}` : null}
        </div>

        <div className="profile-divider" />

        <div className="scheduled-appt-title w-100 profile-signout" onClick={logout}>
          <i className="fal fa-sign-out" />
          &nbsp; Sign Out
        </div>
      </div>

      {/* centered brand */}
      <Link to="/dashboard" className="course-logo-link" onClick={closeProfile}>
        <span className="brand-cosmet">COSMET</span>
        <span className="brand-ink">INK</span>
        <span className="brand-studio">&nbsp;STUDIO</span>
      </Link>

      <div className="PMU-detail-page c" />
    </div>
  );
}
